import React, { useEffect, useState } from "react";
import { Badge, Button, Spinner, Table } from "react-bootstrap";
import rsfservice from "../../../../services/rsfservice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import MoneyBadge from "../common/MoneyBadge";

const AllOrdersDetails = ({ details }) => {
  const [data, setData] = useState(details);
  const [loading, setLoading] = useState(false);

  const FetchOrdersById = async (order_id) => {
    setLoading(true);
    const response = await rsfservice.getOrderById({ order_id: order_id });
    setData(response);
    setLoading(false);
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <div>
      <div className="d-flex justify-content-between">
        <h3>Basic Details</h3>

        <FontAwesomeIcon
          icon={faRefresh}
          onClick={() => FetchOrdersById(data.orderId)}
          style={{ cursor: "pointer" }}
        />
      </div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Key</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Order ID</td>
            <td>{data.orderId}</td>
          </tr>
          <tr>
            <td>Order From</td>
            <td>{data.orderFrom}</td>
          </tr>
          <tr>
            <td>Order To</td>
            <td>{data.orderTo}</td>
          </tr>
          <tr>
            <td>BAP URI</td>
            <td>{data.bap_uri}</td>
          </tr>
          <tr>
            <td>BPP URI</td>
            <td>{data.bpp_uri}</td>
          </tr>
          <tr>
            <td>Domain</td>
            <td>{data.domain}</td>
          </tr>
          <tr>
            <td>Collected By</td>
            <td>{data.collected_by}</td>
          </tr>
        </tbody>
      </Table>

      <h3>Commission Details</h3>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Type</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{data.bap_commision.type}</td>
            <td>{data.bap_commision.value}</td>
          </tr>
        </tbody>
      </Table>

      <h3>Quote Breakup</h3>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Item ID</th>
            <th>Title</th>
            <th>Quantity</th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody>
          {data.quote.breakup.map((item, index) => (
            <tr key={index}>
              <td>{item["@ondc/org/item_id"] || "N/A"}</td>
              <td>{item.title}</td>
              <td>{item["@ondc/org/item_quantity"]?.count || "N/A"}</td>
              <td>
                {item.price?.currency}{" "}
                <MoneyBadge price={item.price?.value} />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <h3>Receiver Bank Details</h3>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Bank Name</th>
            <th>Beneficiary Name</th>
            <th>Branch Name</th>
            <th>Account No</th>
            <th>IFSC Code</th>
            <th>Settlement Type</th>
            <th>Settlement Phase</th>
          </tr>
        </thead>
        <tbody>
          {data.receiver_bank.map((bank, index) => (
            <tr key={index}>
              <td>{bank.bank_name}</td>
              <td>{bank.beneficiary_name}</td>
              <td>{bank.branch_name}</td>
              <td>{bank.settlement_bank_account_no}</td>
              <td>{bank.settlement_ifsc_code}</td>
              <td>{bank.settlement_type}</td>
              <td>{bank.settlement_phase}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default AllOrdersDetails;
